/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The role that is given the ability to send out an invitation to contract in a user with the defined receiver role within the associated region.
 * @export
 * @interface RegionContractingHierarchySenderRole
 */
export interface RegionContractingHierarchySenderRole {
  /**
   * Unique identifier of the role.
   * @type number
   * @memberof RegionContractingHierarchySenderRole
   */
  roleKey: number
  /**
   * Unique name of the role.
   * @type string
   * @memberof RegionContractingHierarchySenderRole
   */
  roleName: string
}

export function RegionContractingHierarchySenderRoleFromJSON(
  json: any
): RegionContractingHierarchySenderRole {
  return RegionContractingHierarchySenderRoleFromJSONTyped(json, false)
}

export function RegionContractingHierarchySenderRoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegionContractingHierarchySenderRole {
  if (json === undefined || json === null) {
    return json
  }
  return {
    roleKey: json['roleKey'],
    roleName: json['roleName'],
  }
}

export function RegionContractingHierarchySenderRoleToJSON(
  value?: RegionContractingHierarchySenderRole | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    roleKey: value.roleKey,
    roleName: value.roleName,
  }
}
